import type { Tenant } from '../payload-types'

/** Helper URL/canonical per-tenant. Permalink articolo = /{slug}/ (come WP). */
export const siteUrl = (t: Pick<Tenant, 'primaryDomain'>) => `https://${t.primaryDomain}`
export const absoluteUrl = (t: Pick<Tenant, 'primaryDomain'>, path: string) =>
  `${siteUrl(t)}${path.startsWith('/') ? path : `/${path}`}`
export const postUrl = (t: Pick<Tenant, 'primaryDomain'>, slug: string) => `${siteUrl(t)}/${slug}/`
export const categoryUrl = (t: Pick<Tenant, 'primaryDomain'>, slug: string) => `${siteUrl(t)}/categoria/${slug}/`
export const authorUrl = (t: Pick<Tenant, 'primaryDomain'>, slug: string) => `${siteUrl(t)}/autore/${slug}/`
